/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { GroupsControllerDeletePrecedenceClauseMutationResponse, GroupsControllerDeletePrecedenceClausePathParams, GroupsControllerDeletePrecedenceClause401, GroupsControllerDeletePrecedenceClause403, GroupsControllerDeletePrecedenceClause404 } from "../../models/documentGroupsController/GroupsControllerDeletePrecedenceClause";

function getGroupsControllerDeletePrecedenceClauseUrl(documentId: GroupsControllerDeletePrecedenceClausePathParams["documentId"], annotationId: GroupsControllerDeletePrecedenceClausePathParams["annotationId"]) {
  const res = { method: 'DELETE', url: `/api/v1/documents/groups/documents/${documentId}/precedence-clauses/${annotationId}` as const }  
  return res
}

/**
 * @description Soft-deletes every entry of the clause; the anchor annotation is left in place. Removing an inferred clause is how a user rejects it. Re-creating after deletion inserts a fresh clause.
 * @summary Remove a precedence clause from a governing document
 * {@link /api/v1/documents/groups/documents/:documentId/precedence-clauses/:annotationId}
 */
export async function groupsControllerDeletePrecedenceClause(documentId: GroupsControllerDeletePrecedenceClausePathParams["documentId"], annotationId: GroupsControllerDeletePrecedenceClausePathParams["annotationId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GroupsControllerDeletePrecedenceClauseMutationResponse, ResponseErrorConfig<GroupsControllerDeletePrecedenceClause401 | GroupsControllerDeletePrecedenceClause403 | GroupsControllerDeletePrecedenceClause404>, unknown>({ method : "DELETE", url : getGroupsControllerDeletePrecedenceClauseUrl(documentId, annotationId).url.toString(), ... requestConfig })  
  return res.data
}